import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  contractListWrapper: {
    height: theme.spacing(52.5),
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    paddingRight: theme.spacing(1),
  },
  contractList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: theme.spacing(10),
    marginTop: theme.spacing(1.5),
  },
  rightSideContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '16px',
    flexShrink: 0,
  },
  loadingSpinner: {
    color: `${theme.palette.labraText.primary} !important`,
    width: theme.spacing(2.5),
    height: theme.spacing(2.5),
  },
  icon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.2, 0, 0),
  },
  text: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.75),
    fontWeight: 500,
    lineHeight: '20px',
    textAlign: 'center',
    textUnderlinePosition: 'from-font',
    textDecorationSkipInk: 'none',
    letterSpacing: '0.1px',
  },
  account: {
    fontFamily: 'Poppins',
    fontSize: theme.spacing(1.5),
    fontWeight: 400,
    lineHeight: '16px',
    textAlign: 'center',
  },
  copyIcon: {
    cursor: 'pointer',
    fontSize: theme.spacing(1.75),
  },
  currency: {
    color: theme.palette.textField.main,
    fontWeight: 400,
    fontSize: theme.spacing(1.75),
    lineHeight: '20px',
    textAlign: 'center',
  },
  renewalIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.75),
    fontSize: theme.spacing(1.75),
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  renewalOffIcon: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    verticalAlign: 'middle',
    padding: theme.spacing(0, 1.125, 0, 0),
  },
  contractRed: {
    color: theme.palette.error.dark,
  },
  contractOrange: {
    color: '#CE8040',
  },
  name: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.spacing(1),
  },
}))
